export const script = `
  const $body = document.querySelector("body");
  const $banner = document.querySelector("[data-component=banner]");
  const $button = document.querySelector("[data-component=menu-button]");
  const $navThings = document.querySelector("[data-component=nav-things]");
  const $title = document.querySelector("[data-component=title]");
  const $titleLink = document.querySelector("[data-component=title-link]");
  const $buttonBack = document.querySelector("[data-component=back-button]");
  const $tier1Menu = document.querySelector("[data-component=tier-1-menu]");
  const $tier2Menu = document.querySelectorAll("[data-component=tier-2-menu]");
  const $tier3Menu = document.querySelectorAll("[data-component=tier-3-menu]");
  const $tier4Menu = document.querySelectorAll("[data-component=tier-4-menu]");
  const $hasTier2Button = document.querySelectorAll("[data-component=tier-2-menu-button] > a");
  const $hasTier3Button = document.querySelectorAll("[data-component=tier-3-menu-button] > a");
  const $hasTier4Button = document.querySelectorAll("[data-component=tier-4-menu-button] > a");

  const usaCities = [
    { name: "New York City", url: "https://www.lonelyplanet.com/usa/new-york-city" },
    { name: "San Francisco", url: "https://www.lonelyplanet.com/usa/san-francisco" },
    { name: "New Orleans", url: "https://www.lonelyplanet.com/usa/new-orleans" },
    { name: "Los Angeles", url: "https://www.lonelyplanet.com/usa/los-angeles" },
    { name: "Boston", url: "https://www.lonelyplanet.com/usa/boston" },
    { name: "Washington, D.C.", url: "https://www.lonelyplanet.com/usa/washington-dc" },
    { name: "Seattle", url: "https://www.lonelyplanet.com/usa/seattle" },
    { name: "Chicago", url: "https://www.lonelyplanet.com/usa/chicago" },
    { name: "Miami", url: "https://www.lonelyplanet.com/usa/miami" },
    { name: "San Diego", url: "https://www.lonelyplanet.com/usa/san-diego" },
    { name: "Nashville", url: "https://www.lonelyplanet.com/usa/nashville" },
    { name: "Portland", url: "https://www.lonelyplanet.com/usa/pacific-northwest/portland" },
    { name: "Sedona", url: "https://www.lonelyplanet.com/usa/southwest/sedona" },
    { name: "Las Vegas", url: "https://www.lonelyplanet.com/usa/las-vegas" },
    { name: "Honolulu", url: "https://www.lonelyplanet.com/usa/honolulu-and-waikiki" },
    { name: "Philadelphia", url: "https://www.lonelyplanet.com/usa/pennsylvania/philadelphia" },
    { name: "Denver", url: "https://www.lonelyplanet.com/usa/rocky-mountains/denver" },
    { name: "Austin", url: "https://www.lonelyplanet.com/usa/austin" },
    { name: "Minneapolis", url: "https://www.lonelyplanet.com/usa/great-lakes/minneapolis" },
    { name: "Houston", url: "https://www.lonelyplanet.com/usa/texas/houston" },
    { name: "Detroit", url: "https://www.lonelyplanet.com/usa/great-lakes/detroit" },
    { name: "Santa Fe", url: "https://www.lonelyplanet.com/usa/santa-fe" },
    { name: "Waikiki", url: "https://www.lonelyplanet.com/usa/hawaii/waikiki" },
    { name: "Atlanta", url: "https://www.lonelyplanet.com/usa/the-south/atlanta" },
    { name: "Key West", url: "https://www.lonelyplanet.com/usa/florida/key-west" },
    { name: "Charleston", url: "https://www.lonelyplanet.com/usa/the-south/charleston" },
    { name: "Dallas", url: "https://www.lonelyplanet.com/usa/texas/dallas" },
    { name: "Orlando", url: "https://www.lonelyplanet.com/usa/florida/orlando" },
    { name: "Flagstaff", url: "https://www.lonelyplanet.com/usa/southwest/flagstaff" },
    { name: "Savannah", url: "https://www.lonelyplanet.com/usa/the-south/savannah" },
    { name: "Richmond", url: "https://www.lonelyplanet.com/usa/virginia/richmond" },
    { name: "Juneau", url: "https://www.lonelyplanet.com/usa/alaska/juneau" },
    { name: "Santa Barbara", url: "https://www.lonelyplanet.com/usa/california/santa-barbara" },
    { name: "Fort Lauderdale", url: "https://www.lonelyplanet.com/usa/florida/fort-lauderdale" },
    { name: "Portland", url: "https://www.lonelyplanet.com/usa/new-england/portland" },
    { name: "Memphis", url: "https://www.lonelyplanet.com/usa/memphis" },
    { name: "San Antonio", url: "https://www.lonelyplanet.com/usa/texas/san-antonio" },
    { name: "Salt Lake City", url: "https://www.lonelyplanet.com/usa/southwest/salt-lake-city" },
    { name: "Baltimore", url: "https://www.lonelyplanet.com/usa/maryland/baltimore" },
    { name: "Pittsburgh", url: "https://www.lonelyplanet.com/usa/pennsylvania/pittsburgh" },
    { name: "Asheville", url: "https://www.lonelyplanet.com/usa/the-south/asheville" },
    { name: "Kailuakona", url: "https://www.lonelyplanet.com/usa/hawaii/kailua-kona" },
    { name: "Anchorage", url: "https://www.lonelyplanet.com/usa/alaska/anchorage" },
    { name: "Albuquerque", url: "https://www.lonelyplanet.com/usa/southwest/albuquerque" },
    { name: "New Orleans", url: "https://www.lonelyplanet.com/usa/new-orleans/faubourg-marigny-and-bywater" },
    { name: "Miami", url: "https://www.lonelyplanet.com/usa/florida/miami/south-beach" },
    { name: "Monterey", url: "https://www.lonelyplanet.com/usa/california/monterey" },
    { name: "Moab", url: "https://www.lonelyplanet.com/usa/southwest/moab" },
    { name: "Santa Cruz", url: "https://www.lonelyplanet.com/usa/california/santa-cruz" },
    { name: "St. Louis", url: "https://www.lonelyplanet.com/usa/great-plains/st-louis" },
    { name: "Taos", url: "https://www.lonelyplanet.com/usa/southwest/taos" },
    { name: "El Paso", url: "https://www.lonelyplanet.com/usa/texas/el-paso" },
    { name: "Boulder", url: "https://www.lonelyplanet.com/usa/rocky-mountains/boulder" },
    { name: "Ketchikan", url: "https://www.lonelyplanet.com/usa/alaska/ketchikan" },
    { name: "San Jose", url: "https://www.lonelyplanet.com/usa/california/san-jose" },
    { name: "St. Augustine", url: "https://www.lonelyplanet.com/usa/florida/st-augustine" },
    { name: "Tucson", url: "https://www.lonelyplanet.com/usa/southwest/tucson" },
    { name: "Fairbanks", url: "https://www.lonelyplanet.com/usa/alaska/fairbanks" },
    { name: "Hanalei", url: "https://www.lonelyplanet.com/usa/hawaii/hanalei" },
  ];

  // Build USA cities list
  // const usaList = document.querySelector("#united-states");
  // const usaItems = [];
  // usaCities.forEach((city) => {
  //   usaItems.push("<li><a href=" + city.url + ">" + city.name + "</a></li>");
  // });
  // usaList.innerHTML = usaItems.join("");

  var tier = "1";
  var currentTitle = "";
  var currentTitleUrl = "";
  var lastTitleTier2 = "";
  var lastTitleUrlTier2 = "";
  var lastTitleTier3 = "";
  var lastTitleUrlTier3 = "";
  var lastTitleTier4 = "";
  var lastTitleUrlTier4 = "";

  $button.addEventListener("click", (event) => {
    if ($navThings.hidden) {
      $navThings.hidden = false;
    }

    if ($body.dataset.navOpen === "true") {
      $body.removeAttribute("data-nav-open");
      $body.removeAttribute("data-scroll-locked");

      // Reset back button
      $buttonBack.removeEventListener("click", tierBackButtonClick);
      $buttonBack.hidden = true;
      tier = "1";

      lastTitleTier2 = "";
      lastTitleTier3 = "";
      lastTitleTier4 = "";
      currentTitle = "";
      currentTitleUrl = "";
      $title.innerText = "";
      $titleLink.innerHTML = "";

      // Reset menus
      setTimeout(() => {
        $tier1Menu.classList.remove(
          "tier-2-visible",
          "tier-3-visible",
          "tier-4-visible"
        );
      }, 250);

      $tier2Menu.forEach(($menu) => {
        $menu.hidden = true;
        // $menu.scrollTop = 0;
      });

      $tier3Menu.forEach(($menu) => {
        $menu.hidden = true;
        // $menu.scrollTop = 0;
      });

      $tier4Menu.forEach(($menu) => {
        $menu.hidden = true;
        // $menu.scrollTop = 0;
      });
    } else {
      $body.dataset.navOpen = "true";
      $body.dataset.scrollLocked = "true";
      // $navThings.hidden = true;
    }
  });

  $hasTier2Button.forEach(($button) => {
    $button.addEventListener("click", (event) => {
      event.preventDefault();

      lastTitleTier2 = event.target.innerText;
      lastTitleUrlTier2 = "";
      currentTitle = event.target.innerText;
      currentTitleUrl = "";
      $title.innerText = currentTitle;
      $titleLink.innerHTML = "";

      const menuId = event.target.dataset.menu;
      const $menu = document.getElementById(menuId);

      tier = "2";
      $navThings.hidden = true;
      $tier1Menu.classList.add("tier-2-visible");
      $menu.hidden = false;

      $buttonBack.hidden = false;
      $buttonBack.addEventListener("click", tierBackButtonClick, false);

      $tier2Menu.forEach(($menu) => {
        $menu.scrollTop = 0;
      });

      return false;
    });
  });

  $hasTier3Button.forEach(($button) => {
    $button.addEventListener("click", (event) => {
      event.preventDefault();

      lastTitleTier3 = event.target.innerText;
      lastTitleUrlTier3 = event.target.href;
      currentTitle = event.target.innerText;
      currentTitleUrl = event.target.href;
      $title.innerText = currentTitle;
      $titleLink.innerHTML = "<a href=" + currentTitleUrl + ">Explore " + currentTitle + "</a>";

      const menuId = event.target.dataset.menu;
      const $menu = document.getElementById(menuId);

      tier = "3";
      $tier1Menu.classList.add("tier-3-visible");
      $menu.hidden = false;

      $tier3Menu.forEach(($menu) => {
        $menu.scrollTop = 0;
      });

      return false;
    });
  });

  $hasTier4Button.forEach(($button) => {
    $button.addEventListener("click", (event) => {
      event.preventDefault();

      lastTitleTier4 = event.target.innerText;
      lastTitleUrlTier4 = event.target.href;
      currentTitle = event.target.innerText;
      currentTitleUrl = event.target.href;
      $title.innerText = currentTitle;
      $titleLink.innerHTML = "<a href=" + currentTitleUrl + ">Explore " + currentTitle + "</a>";

      const menuId = event.target.dataset.menu;
      const $menu = document.getElementById(menuId);

      tier = "4";
      $tier1Menu.classList.add("tier-4-visible");
      $menu.hidden = false;

      $tier4Menu.forEach(($menu) => {
        $menu.scrollTop = 0;
      });

      return false;
    });
  });

  const tierBackButtonClick = (event) => {
    if (event.type === "click") {
      event.preventDefault();
    }

    // Fix strange bug where sometimes in iOS, hidden is added to header. Quick hacky fix, not spending time figuring it out.
    if ($banner.hidden) {
      $banner.hidden = false;
    }

    if (tier === "2") {
      $title.innerText = "";
      $titleLink.innerHTML = "";
      $tier1Menu.classList.remove("tier-2-visible");
      tier = "1";
      $buttonBack.hidden = true;
      $navThings.hidden = false;
      $tier2Menu.forEach(($menu) => {
        $menu.hidden = true;
      });
    }

    if (tier === "3") {
      $title.innerText = lastTitleTier2;
      $titleLink.innerHTML = "";
      $tier1Menu.classList.remove("tier-3-visible");
      tier = "2";
      $tier3Menu.forEach(($menu) => {
        $menu.hidden = true;
      });
    }

    if (tier === "4") {
      $title.innerText = lastTitleTier3;
      $titleLink.innerHTML = "<a href=" + lastTitleUrlTier3 + ">Explore " + lastTitleTier3 + "</a>";
      $tier1Menu.classList.remove("tier-4-visible");
      tier = "3";
      $tier4Menu.forEach(($menu) => {
        $menu.hidden = true;
      });
    }

    return false;
  };
`;
